import gql from 'graphql-tag'

export const fetchAutopayRedirection = gql(`
query getRedirectUrl($orderNumber: String!) {
  redirectUrl(order_number: $orderNumber)
}
`)
